<template>
    <header class="app-header">
        <div class="container">
            <div class="header-content">
                <div class="logo-section">
                    <router-link to="/e-commerce-web" class="logo">
                        <div class="logo-icon">🛒</div>
                        <h1 class="store-name">{{ storeName }}</h1>
                    </router-link>
                </div>

                <SearchBar class="desktop-search" />

                <div class="header-actions">
                    <button class="cart-btn" @click="toggleCart" aria-label="Shopping Cart">
                        <span class="cart-icon">🛒</span>
                        <span v-if="cartItemCount > 0" class="cart-badge">
                            {{ cartItemCount }}
                        </span>
                    </button>
                </div>
            </div>

            <SearchBar class="mobile-search" />
        </div>
    </header>
</template>

<script>
import SearchBar from './SearchBar.vue'
import { mapGetters, mapActions } from 'vuex'

export default {
    name: 'AppHeader',
    components: {
        SearchBar
    },
    data() {
        return {
            storeName: 'TechStore'
        }
    },
    computed: {
        ...mapGetters({
            cartItemCount: 'ecommerce/cart/cartItemCount',
        }),
    },
    methods: {
        toggleCart() {
            this.$store.dispatch('ecommerce/cart/toggleCart');
        },
    }
}
</script>

<style scoped>
.app-header {
    background: white;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
    position: sticky;
    top: 0;
    z-index: 1000;
}

.container {
    max-width: 1200px;
    margin: 0 auto;
    padding: 0 20px;
}

.header-content {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 15px 0;
}

.logo {
    display: flex;
    align-items: center;
    text-decoration: none;
    color: inherit;
}

.logo-icon {
    font-size: 28px;
    margin-right: 10px;
}

.store-name {
    font-size: 24px;
    font-weight: 700;
    color: #333;
    margin: 0;
}

.desktop-search {
    flex: 1;
    max-width: 500px;
    margin: 0 30px;
}

.mobile-search {
    display: none;
    margin-bottom: 15px;
}

.cart-btn {
    position: relative;
    background: none;
    border: none;
    cursor: pointer;
    font-size: 24px;
    padding: 5px;
}

.cart-badge {
    position: absolute;
    top: -5px;
    right: -5px;
    background: #ff4757;
    color: white;
    font-size: 12px;
    font-weight: bold;
    min-width: 20px;
    height: 20px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 2px;
}

@media (max-width: 768px) {
    .desktop-search {
        display: none;
    }

    .mobile-search {
        display: block;
    }

    .store-name {
        font-size: 20px;
    }
}
</style>